// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/lib/notice-bar/index.css
// module id = 182
// module chunks = 1